import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { authAPI, myVehiclesAPI } from '../services/api';
import { vehicleStore } from '../services/vehicleStore';
import { garageStore } from '../services/garageStore';
import { useT } from '../services/i18n';

// Keeps the selected vehicle in sync with the customer's account (save on select, restore on another device)
const VehicleSync = () => {
  const { t } = useT();
  const { pathname } = useLocation();
  const restoredFor = useRef(null);

  useEffect(() => vehicleStore.onSync(async (vehicle) => {
    if (!authAPI.isAuthenticated() || !vehicle?.brand) return;
    try {
      const r = await myVehiclesAPI.sync(vehicle);
      garageStore.invalidate();
      if (r?.created) toast.success(t('garage.savedToast'), { duration: 2500 });
    } catch { /* offline or expired session: local selection still works */ }
  }), [t]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token || !authAPI.isAuthenticated()) { if (!token) { restoredFor.current = null; garageStore.reset(); } return; }
    if (restoredFor.current === token) return;
    restoredFor.current = token;
    garageStore.load(true);
    if (vehicleStore.get()) return;
    myVehiclesAPI.last().then(v => {
      if (!v || vehicleStore.get()) return;
      vehicleStore.set({ brand: v.brand, model: v.model, year: v.year, engine: v.engine, plate: v.plate }, { silent: true });
      toast.success(t('garage.restoredToast', { v: `${v.brand} ${v.model}` }), { duration: 3500 });
    }).catch(() => {});
  }, [pathname, t]);

  return null;
};

export default VehicleSync;
